import React from 'react';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';

interface ChatToggleProps {
  onClick: () => void;
  isOpen: boolean;
}

export function ChatToggle({ onClick, isOpen }: ChatToggleProps) {
  return (
    <Button
      onClick={onClick}
      size="lg"
      className={`fixed bottom-6 right-6 z-40 rounded-full shadow-lg transition-all duration-300 ${
        isOpen ? 'scale-95 opacity-70' : 'scale-100 hover:scale-105'
      }`}
    >
      <MessageCircle className="h-6 w-6" />
      <span className="ml-2 hidden sm:inline">Chat with Charlie</span>
    </Button>
  );
}
